import axios from 'axios'
import GenericViewMixin from './GenericViewMixin'
import gateways from '../collections/gateways'
import { errorCodes, failedReasons } from '../helpers/paymentErrors'

export default {
  mixins: [
    GenericViewMixin
  ],
  props: {
    testMode: {
      type: Boolean,
      required: false
    }
  },
  data: () => ({
    activeGateway: null,
    gatewayError: '',
    gateways: gateways,
    loaderPay: false
  }),
  methods: {
    /**
     * `code_error` the API returns in the body of a 400, or '' when absent.
     */
    gatewayErrorCode (error) {
      const data = (error && error.response && error.response.data) || {}
      return data.code_error || ''
    },
    /**
     * Turn an API error into a message the payer can act on.
     *
     * Falls back to a generic sentence rather than surfacing the raw Error
     * object, which is what payExternalGateway used to render as
     * "[object Object]".
     */
    resolveGatewayError (error) {
      // Cancelled by navigation: not something the payer did.
      if (axios.isCancel(error)) {
        return ''
      }
      const data = (error && error.response && error.response.data) || null
      if (data) {
        if (data.code_error && errorCodes[data.code_error]) {
          return errorCodes[data.code_error]
        }
        if (data.failed_reason && failedReasons[data.failed_reason]) {
          return failedReasons[data.failed_reason]
        }
        const nonField = data.non_field_errors
        if (Array.isArray(nonField) && nonField.length) {
          // The API embeds the canonical reason inside an English sentence
          // ("Payment authorization failed. Failed reason is card_invalid"),
          // so match on it before falling back to showing that sentence.
          const matched = Object.keys(failedReasons).find(reason => nonField[0].includes(reason))
          return matched ? failedReasons[matched] : nonField[0]
        }
      }
      return 'No pudimos procesar tu pago. Intenta nuevamente en unos minutos.'
    },
    /**
     * Message for a canonical failed_reason read off the payment itself.
     */
    failedReasonMessage (reason) {
      return failedReasons[reason] || failedReasons.not_specified
    },
    createSource (gateway, client = null) {
      return new Promise((resolve, reject) => {
        const payload = {
          gateway: gateway,
          payment: this.payment.id,
          amount: this.payment.balance,
          usage: 'single'
        }
        if (client) {
          payload.client = client
        }
        if (this.payment.customer) {
          payload.customer = this.payment.customer.id
        }
        this.$store.dispatch('payments/CREATE', {
          resource: 'sources',
          payload: payload,
          headers: {
            headers: {
              'x-simple-workspace': this.payment.account.id
            }
          }
        })
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
      })
    },
    authorizePayment () {
      return new Promise((resolve, reject) => {
        const payload = {
          source: this.source.id
        }
        if (this.payment.invoice) {
          payload.invoice = this.payment.invoice.id
        }
        this.$store.dispatch('payments/CREATE', {
          resource: 'payments',
          id: this.payment.id,
          detail: 'authorize',
          payload: payload
        })
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
      })
    },
    capturePayment () {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('payments/RETRIEVE', {
          resource: 'payments',
          id: this.payment.id,
          detail: 'capture'
        })
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
      })
    },
    async payExternalGateway (gateway) {
      try {
        this.loaderPay = true
        await this.createSource(gateway)
        await this.authorizePayment()
        window.location.replace(this.paymentsDetail.links.process_url)
      } catch (error) {
        this.gatewayError = error
      } finally {
        this.loaderPay = false
      }
    }
  }
}